import { render, staticRenderFns } from "./Configure3DModelScaleSlider.vue?vue&type=template&id=21a1b95f&scoped=true&"
import script from "./Configure3DModelScaleSlider.vue?vue&type=script&lang=js&"
export * from "./Configure3DModelScaleSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1b95f",
  null
  
)

export default component.exports